import React, { useState } from "react";
import AsideText from "./mdx/text/Aside";
import H2 from "./mdx/text/H2";

export const Item = ({ href, children }) => {
	if (!href) {
		return <span>{children}</span>;
	}

	return (
		<a href={href} target="_blank" rel="noopener noreferrer">
			{children}
		</a>
	);
};

export const Sources = ({ children, initiallyVisibleCount = 2 }) => {
	const [showAll, setShowAll] = useState(false);

	const items = React.Children.toArray(children).filter(Boolean);

	const handleToggle = () => {
		setShowAll((prev) => !prev);
	};

	return (
		<AsideText lightBackground>
			<div className="sources-container">
				<H2 format>Źródła</H2>

				<ul id="sources-list" aria-live="polite">
					{items.map((item, index) => {
						const isVisible = showAll || index < initiallyVisibleCount;

						return (
							<li
								key={index}
								className={isVisible ? "source-visible" : "source-hidden"}
								aria-hidden={!isVisible}
							>
								{item}
							</li>
						);
					})}
				</ul>

				{items.length > initiallyVisibleCount && (
					<button
						type="button"
						onClick={handleToggle}
						aria-expanded={showAll}
						aria-controls="sources-list"
						className="pd-btn pd-btn--link"
					>
						{showAll ? "Pokaż mniej" : "Pokaż więcej"}
					</button>
				)}
			</div>
		</AsideText>
	);
};
